// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1cXJL","fs":"Modal_fs__1ig4z","docked":"Modal_docked__yb-5V"};